import { Icon, IconProps } from './Icon';

export const CulturalNormsRulesIcon = ({ color = 'currentColor', ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      d="M12 3C16.982 3 21 7.018 21 12C21 16.982 16.982 21 12 21"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M12 21C7.018 21 3 16.982 3 12C3 7.018 7.018 3 12 3"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.168 4.05975C7.27799 8.88475 7.27799 15.1158 10.168 19.9408C11.014 21.3538 12.987 21.3538 13.833 19.9408C16.723 15.1158 16.723 8.88475 13.833 4.05975C12.986 2.64675 11.014 2.64675 10.168 4.05975Z"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M3 12H21"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
